import { defineStore } from "pinia";
import { ref } from 'vue';

export const useNoQrcodeOverlay = defineStore("noQrcodeOverlay", () => {
  const is_visible = ref<boolean>(false);
  function show(): void {
    console.log("[no-qr-code-overlay.show]: showing no-qr-code-overlay");
    is_visible.value = true;
  }
  function hide(): void {
    console.log("[no-qr-code-overlay.hide]: hiding no-qr-code-overlay");
    is_visible.value = true;
  }

  return { is_visible, show, hide };
});

// vim: softtabstop=2:shiftwidth=2
